import React from "react";

const DOT_STYLE = {
  borderRadius: "7.236px",
  width: "7.236px",
  height: "7.236px",
};

export default function Riskometer({ value }) {
  return (
    <div className="flex justify-center items-center" style={{ gap: "3.75px" }}>
      {[1, 2, 3, 4, 5].map((level) => (
        <div
          key={level}
          style={{
            ...DOT_STYLE,
            background: value >= level ? "#20E083" : "#DDDFED",
          }}
        />
      ))}
    </div>
  );
}
